import { supabase } from '../client/supabaseClient';

export interface ShopRegistrationData {
  shopId?: string | null;
  name: string;
  ownerName: string; // Assuming this is the owner's name
  address: string;
  city: string;
  state: string; // Added field
  postalCode: string; // Changed to string to match DB varchar type
  contactPhone: string;
  contactEmail: string; // Added field
  lat: number | null;
  lon: number | null;
  secret: string;
}

interface RegisterShopResponse {
  success: boolean;
  shop_id: string;
  error?: string;
}

/**
 * Registers a new shop with the provided information.
 * @param data The shop registration data
 * @returns Promise<RegisterShopResponse>
 * @throws Error if registration fails
 */
export async function registerShop(data: ShopRegistrationData): Promise<RegisterShopResponse> {
  try {
    const { data: response, error } = await supabase.schema('api').rpc('register_shop', {
      shopid: data.shopId || null,
      shop_name: data.name,
      contact_name: data.ownerName, 
      contact_email: data.contactEmail,// Assuming contact name is the same as shop name
      contact_phone: data.contactPhone, // Added field
      address: data.address,
      city: data.city,
      state: data.state, // Added field
      pincode: data.postalCode,
      lat: data.lat,
      lon: data.lon,
      secret: data.secret
    });

    if (error) {
      console.error('Supabase RPC error:', error);
      throw new Error(error.message || 'Failed to register shop');
    }

    if (!response) {
      throw new Error('No response received from server');
    }

    const result = response as RegisterShopResponse;
    if (!result.success) {
      throw new Error(result.error || 'Shop registration failed');
    }

    return result;
  } catch (error) {
    console.error('Unexpected error in registerShop:', error);
    throw error instanceof Error ? error : new Error('An unexpected error occurred');
  }
}

